/* TEXT HELPERS */

.display-1 {
  font-size: var(--display-1-size);
  line-height: 1.2;
  font-weight: normal !important;
}

.display-2 {
  font-size: var(--display-2-size);
  line-height: 1.1;
  font-weight: normal !important;
  margin-bottom: var(--spacer);
}

@media screen and (max-width: 1600px) {
  .display-2 {
    font-size: var(--body-size-large);
  }
}

.body-copy {
  font-size: var(--body-size);
  line-height: 1.4;
}

.text-medium {
  font-weight: 500 !important;
}

.text-uppercase {
  text-transform: uppercase;
}

.text-semibold {
  font-weight: 600 !important;
}

.text-bold {
  font-weight: 700 !important;
}

.text-line-through {
  text-decoration: line-through;
}

.text-link,
.text-link:active,
.text-link:visited {
  color: var(--blue-layout-300-active);
}

.text-center {
  text-align: center;
}

.text-end {
  text-align: end;
}

.text-start {
  text-align: start;
}

.break-all {
  word-break: break-all;
}

.chart-tooltip-title {
  font-size: var(--body-size-xxlarge);
  line-height: 1.1;
  color: var(--main-titles-inputs-600);
  margin-bottom: calc(var(--spacer) * 2);
}

.text-primary {
  font-family: var(--font-family);
}

.text-secondary {
  font-family: var(--font-family-secondary);
}

.number {
  font-family: var(--font-family-secondary);
}

.number-mono {
  font-family: var(--font-family-secondary-mono);
}
